import React, { Component } from 'react';
import moment from 'moment';

import { latestStatus } from '../../utils/Utils';

class OrderDetailStatus extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedAction: ''
    }
  }

  onActionSelected(e) {
    this.setState({ selectedAction: e.target.value }, () => {

      if (this.state.selectedAction === '1') {
        this.trackingNumberInout.focus();
      }
    });
  }

  onSavePress() {
    const { selectedAction } = this.state;
    const { onShipOrdePress, onCancelOrderPress } = this.props;

    if (selectedAction === '1') {
      // Ship
      onShipOrdePress(this.trackingNumberInout.value);
    } else if (selectedAction === '2') {
      onCancelOrderPress();
    }
  }

  renderStatusIcon(latestStatus, status) {

    let progress = null;

    switch (latestStatus) {
      case 'payment':
        progress = (
          <div className="row">
            <div className="col">
              <img src="/resources/img/ic-awaiting_payment.svg" alt="" />
              <p>
                <span>{'Awaiting Payment'}</span>
                <br />{moment(status.payment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-awaiting_shipment.png" alt="" />
              <p>
                <span>{'Awaiting Shipment'}</span>
                <br />
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-shipped.png" alt="" />
              <p>
                <span>{'Shipped'}</span>
                <br />
              </p>
            </div>
          </div>
        );
        break;
      case 'shipment':
        progress = (
          <div className="row">
            <div className="col">
              <img src="/resources/img/ic-awaiting_payment.svg" alt="" />
              <p>
                <span>{'Order Made'}</span>
                <br />{moment(status.payment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-awaiting_shipment-success.svg" alt="" />
              <p>
                <span>{'Paid / Awaiting Shipment'}</span>
                <br />{moment(status.shipment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-shipped.png" alt="" />
              <p>
                <span>{'Shipped'}</span>
                <br />
              </p>
            </div>
          </div>
        );
        break;
      case 'shipped':
        progress = (
          <div className="row">
            <div className="col">
              <img src="/resources/img/ic-awaiting_payment.svg" alt="" />
              <p>
                <span>{'Order Made'}</span>
                <br />{moment(status.payment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-awaiting_shipment-success.svg" alt="" />
              <p>
                <span>{'Paid / Awaiting Shipment'}</span>
                <br />{moment(status.shipment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
              <img src="/resources/img/ic-shipped-success.svg" alt="" />
              <p>
                <span>{'Shipped'}</span>
                <br />{moment(status.shipped).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
          </div>
        );
        break;
      case 'canceled':
        progress = (
          <div className="row">
            <div className="col">
              <img src="/resources/img/ic-awaiting_payment_canceled.png" alt="" />
              <p>
                <span>{'Order Made'}</span>
                <br />{moment(status.payment).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
            <div className="col">
            </div>
            <div className="col">
              <img src="/resources/img/ic-canceled.png" alt="" />
              <p>
                <span>{'Order Canceled'}</span>
                <br />{moment(status.canceled).format('DD MMM YYYY, HH:mm')}
              </p>
            </div>
          </div>
        );
        break;
    }

    return progress;
  }

  renderProgress(latestStatus) {

    let progress = null;
    switch (latestStatus) {
      case 'payment':
        // awaiting payment
        progress = (
          <ul className="progress-tracker">
            <li className="progress-step is-active">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step">
              <span className="progress-marker"></span>
            </li>
          </ul>
        );
        break;
      case 'shipment':
        // awaiting shipment
        progress = (
          <ul className="progress-tracker">
            <li className="progress-step is-complete">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step is-active">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step">
              <span className="progress-marker"></span>
            </li>
          </ul>
        );
        break;
      case 'shipped':
        // shipped
        progress = (
          <ul className="progress-tracker">
            <li className="progress-step is-complete">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step is-complete">
              <span className="progress-marker"></span>
            </li>
            <li className="progress-step is-complete">
              <span className="progress-marker"></span>
            </li>
          </ul>
        );
        break;
      case 'canceled':
        // #ff3b30
        progress = (
          <ul className="progress-tracker">
            <li className="progress-step is-cancel">
              <span className="progress-marker" />
            </li>
            <li className="progress-step is-cancel">
              <span className="progress-marker" />
            </li>
          </ul>
        );
        break;
    }
    return progress;
  }

  renderActionMenu(status) {

    if (status === 'canceled') {
      return null;
    }

    const { selectedAction } = this.state;

    return (
      <div>
        <div className="shipped">
          <div className="form-group radio-btn">
            <div className="radio radio-green">
              <input
                type="radio"
                className="shipped"
                name="shipped"
                id="radio1"
                value="1"
                onChange={this.onActionSelected.bind(this)}
              />
              <label htmlFor="radio1">
                {'Ship'}
              </label>
            </div>
            <div className="radio radio-green">
              <input
                type="radio"
                className="cancel"
                name="shipped"
                id="radio2"
                value="2"
                onChange={this.onActionSelected.bind(this)}
              />
              <label htmlFor="radio2">
                {'Cancel'}
              </label>
            </div>
          </div>
        </div>
        {selectedAction === '1' ? this.renderTrackingNumber() : null}
        <div className="btn-save">
          <button
            className={`btn button green-btn ${selectedAction === '' ? 'disable' : ''}`}
            type="submit"
            onClick={this.onSavePress.bind(this)}
          >
            {'Save'}
          </button>
        </div>
      </div>
    );
  }

  renderTrackingNumber() {
    return (
      <div className="form-group input-txt">
        <label htmlFor="tracking-id">Tracking Number</label>
        <input
          type="text"
          className="form-control"
          name="tracking-id"
          placeholder="Tracking Number"
          ref={(input) => { this.trackingNumberInout = input; }}
        />
      </div>
    );
  }

  render() {
    const { order } = this.props;

    // const status = latestStatus(order.status);
    const status = 'shipped';

    return (
      <div className="shipped-tracking">
        {this.renderStatusIcon(status, order.status)}
        {this.renderProgress(status)}
        {this.renderActionMenu(status)}
      </div>
    );
  }
}

export default OrderDetailStatus;



// WEBPACK FOOTER //
// ./src/views/orders/OrderDetailStatus.js